"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  type: _propTypes.default.string,
  children: _propTypes.default.object,
  styles: _propTypes.default.object,
  setVisibility: _propTypes.default.func,
  getCursorPos: _propTypes.default.func
};

function Hover(props) {
  var _props$children$props = props.children.props,
      setVisibility = _props$children$props.setVisibility,
      getCursorPos = _props$children$props.getCursorPos,
      styles = _props$children$props.styles;
  return _react.default.createElement("div", {
    onMouseOver: function onMouseOver() {
      return setVisibility(true);
    },
    onMouseOut: function onMouseOut() {
      return setVisibility(false);
    },
    onMouseMove: function onMouseMove(e) {
      return getCursorPos(e);
    },
    style: styles
  }, props.children.props.children);
}

Hover.propTypes = propTypes;
var _default = Hover;
exports.default = _default;
//# sourceMappingURL=Hover.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-hover/dist/lib/Hover.js
// module id = 1087
// module chunks = 0